import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { formatStorePrice } from '../../../utils/ecommerce/currency.js';
import PaymentOptionAssets from '../../Cart/components/PaymentOptionAssets';
import { createFocusTrap } from 'focus-trap';

const appRoot = document.getElementById('main-content');

class FlyoutComponent extends Component {
	constructor(props) {
		super(props);
		//TODO: remove testing string after issue with window storeVariables is resolved.
		this.cartUrl = window.storeVariables.cartUrl;
		this.state = {
			isAnimationOn: false,
		};
		this.cardPaymentsOptions = this.props.cardPaymentsOptions;

		this.labels = this.getTemplateLabels();
		if (this.labels) {
			console.info('[FLYOUT v.2.0.1b]');
		}
		this.handleCloseFlyout = this.handleCloseFlyout.bind(this);
		this.handleCloseFlyoutOnEscape = this.handleCloseFlyoutOnEscape.bind(this);
		this.modalRef = React.createRef();
	}

	componentDidMount() {
		window.addEventListener('keydown', this.handleCloseFlyoutOnEscape);
	}

	componentDidUpdate(prevProps) {
		// On modal close
		if (Array.isArray(this.props.cart) && this.state.isAnimationOn == true) {
			this.setAnimationOff();
			if (this.focusTrap) this.focusTrap.deactivate();
		}

		// On modal open
		if (this.modalRef?.current && this.props.cart && Array.isArray(prevProps.cart) && prevProps.cart.length === 0) {
			// Start animation
			setTimeout(() => {
				this.modalRef.current.classList.add('calcite-animate__in');
			});

			// Wait for modal to become visible
			const observer = new IntersectionObserver(([_]) => {
				if (!this.modalRef.current) return;

				// Activate focus trap when modal becomes visible
				this.focusTrap = createFocusTrap(this.modalRef.current, { tabbableOptions: { getShadowRoot: true }, allowOutsideClick: true });
				this.focusTrap.activate();
				observer.disconnect();
			});
			observer.observe(this.modalRef.current);
		}
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.handleCloseFlyoutOnEscape);
	}

	getTemplateLabels() {
		let flyoutShell = document.querySelector('.flyout-shell');
		if (flyoutShell) {
			let flyoutLabels = JSON.parse(flyoutShell.getAttribute('data-flyout-labels'));
			return flyoutLabels;
		}
		console.info('[NO FLYOUT component found]');
		return null;
	}

	setAnimationOff() {
		this.setState({ isAnimationOn: false });
	}

	handleCloseFlyout() {
		this.setState(
			{
				isAnimationOn: true,
			},
			() => {
				setTimeout(() => {
					this.props.setCart([]);
				}, 550);
			}
		);
	}

	handleCloseFlyoutOnEscape(e) {
		// Return if flyout is not open
		if (!this.labels) return;
		if (Array.isArray(this.props.cart) || this.props.cart.isNewProd == false) return;

		if (e.key === 'Escape') {
			this.handleCloseFlyout();
		}
	}

	render() {
		const { cart } = this.props;
		if (!this.labels) {
			return null;
		}
		if (Array.isArray(cart) || cart.isNewProd == false) {
			return null;
		}

		function isPropPresent(objString, obj) {
			let propIsPresent = true;
			let _model = null;
			if (objString.indexOf('.') > -1) {
				let objArr = objString.split('.');
				objArr.shift();
				if (objArr.length > 2) {
					objArr.forEach((prop, indx) => {
						if (objArr.length == indx) {
							propIsPresent = true;
						} else if (_model != null) {
							if (Object.prototype.toString.call(_model) === '[object Object]' && prop in _model) {
								_model = _model[prop];
							} else {
								propIsPresent = false;
							}
						} else if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
							_model = Object.assign({}, obj[prop]);
						} else {
							propIsPresent = false;
						}
					});
				} else {
					propIsPresent = obj[objArr[0]] ? true : false;
				}
			} else {
				propIsPresent = false;
			}
			return propIsPresent;
		}

		let animate = this.state.isAnimationOn ? ' calcite-animate__out' : '';
		let numericSubtotal = 0;
		let itemQty = 0;
		let addedItemTitle = '';
		// calculate subtotal
		if ('lineItems' in cart) {
			cart.lineItems.forEach((item) => {
				numericSubtotal += item.price * item.quantity;
				itemQty += item.quantity;
			});
			addedItemTitle = cart.newProdTile;
		}
		let subtotal = formatStorePrice(numericSubtotal, cart.metadata.formattedLocale, cart.metadata.currency);
		let hasCardOptions = !this.cardPaymentsOptions || !this.cardPaymentsOptions.length ? false : true;

		return ReactDOM.createPortal(
			<React.Fragment>
				<div className={`co3-modal-mp${animate} co3-modal flyout-component`} tabIndex="0" onClick={this.handleCloseFlyout}></div>
				<div
					ref={this.modalRef}
					className={`flyout calcite-animate ${animate}`}
					data-expanded="false"
					data-tabbable-attr="modal"
					aria-modal="true"
					role="dialog"
					aria-labelledby="flyout-heading">
					<div className="flyout__header">
						<h2 id="flyout-heading" className="flyout__checkmark trailer-0 font-size-2 esri-font-demi">
							{this.labels.flyoutTitle}
						</h2>
						<calcite-button
							onClick={this.handleCloseFlyout}
							label={Granite.I18n.get('Close')}
							appearance="transparent"
							color="neutral"
							kind="neutral"
							scale="m"
							alignment="center"
							width="auto"
							class="flyout__close">
							<calcite-icon icon="x" scale="m" aria-hidden="true"></calcite-icon>
						</calcite-button>
					</div>
					<div className="flyout__content">
						<p className="flyout__description flyout__description--bold text-black">{addedItemTitle}</p>
						<p className="flyout__description text-black">
							{this.labels.flyoutCartQty} {itemQty}
						</p>
						<div
							className="calcite-button-wrapper flyout__cta"
							data-event="track-component"
							data-component-link-placement="1"
							data-component-link-type="button"
							data-component-name="buy page - go to cart"
							data-component-link="buy page - go to cart">
							<calcite-button href={this.cartUrl} appearance="solid" kind="brand">
								<div class="flyout__cta-slotted-content">{this.labels.flyoutCtaLabel}</div>
							</calcite-button>
						</div>
					</div>
					<div className="flyout__footer">
						{hasCardOptions && this.labels.moneyBackMessage && <p class="font-size--1 trailer-half">{this.labels.moneyBackMessage}</p>}
						{hasCardOptions && (
							<PaymentOptionAssets
								paymentAssets={this.cardPaymentsOptions}
								purchaseOrderLabel={this.labels.purchaseOrderLabel}
								authorizationToInvoiceLabel={this.labels.authorizationToInvoiceLabel}
							/>
						)}
					</div>
				</div>
			</React.Fragment>,
			appRoot
		);
	}
}

function mapStateToProps(state) {
	return state;
}

export default connect(mapStateToProps, actions)(FlyoutComponent);
